import { type ReactNode } from "react";
import { useAuth } from "@/context/AuthContext";
import { signInUrl } from "@/lib/auth-url";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-zinc-400 text-sm">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (status === "unauthenticated") {
    const redirectUrl = signInUrl(window.location.href);
    window.location.href = redirectUrl;
    return (
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-zinc-400 text-sm">Redirecting to sign in...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
